import { render, staticRenderFns } from "./GlAlerts.vue?vue&type=template&id=a2425686&scoped=true&"
import script from "./GlAlerts.vue?vue&type=script&lang=js&"
export * from "./GlAlerts.vue?vue&type=script&lang=js&"
import style0 from "./GlAlerts.vue?vue&type=style&index=0&id=a2425686&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2425686",
  null
  
)

export default component.exports